// Einfacher Lösch-Bestätigungsdialog — extrahiert aus AppointmentsPage.js.
import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export const DeleteConfirmDialog = ({ open, onOpenChange, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm">
      <DialogHeader>
        <DialogTitle>Termin löschen?</DialogTitle>
      </DialogHeader>
      <p className="text-sm text-gray-600">
        Möchten Sie diesen Termin wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.
      </p>
      <div className="flex gap-3 pt-4">
        <Button
          type="button"
          variant="outline"
          onClick={() => onOpenChange(false)}
          className="flex-1"
        >
          Abbrechen
        </Button>
        <Button
          onClick={onConfirm}
          variant="destructive"
          className="flex-1"
        >
          Löschen
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
